import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import DrawerContent from 'components/DrawerContent/DrawerContent';
import Button from 'components/Button/Button';

import styles from './BottomDrawer.css';


const BottomDrawer = (props) => {
  const { children, onClose, ...rest } = props;

  const closeElement = useMemo(() => {
    if (!onClose) {
      return null;
    }

    return (
      <div className={styles.closeSection}>
        <Button
          colour="link"
          id="CloseMobileBottomDrawer"
          onClick={onClose}
        >
          {translate('v2profile.button.close')}
        </Button>
      </div>
    );
  }, [onClose]);

  return (
    <DrawerContent
      {...rest}
      side="bottom"
      onClose={onClose}
    >
      {children}
      {closeElement}
    </DrawerContent>
  );
};

BottomDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
};

BottomDrawer.defaultProps = { onClose: undefined };

export default BottomDrawer;
